// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"VideoPlayer_wrapper__rby9P","videoInOverlay":"VideoPlayer_videoInOverlay__zDDRI","opener":"VideoPlayer_opener__oLy0C"};